import { render, staticRenderFns } from "./EditReservations.vue?vue&type=template&id=4f52c9f9"
import script from "./EditReservations.vue?vue&type=script&lang=js"
export * from "./EditReservations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports